import Splide from '@splidejs/splide'

function init() {
    'use strict'

    const lendersSliderSplide = new Splide('.js_financeLendersSlider', {
        gap: 40,
        arrows: false,
        autoplay: true,
        drag: 'free',
        autoWidth: true
    }).mount()
}

$(document).ready(init)